module.exports = "/images/vendor/flag-icon-css/flags/1x1/fk.svg?aeb2d58832c6dc501253d235d5467fe3";